import { Modal } from "@mui/material";
import React from "react";

import type { TDefaultModalProps } from "./types";

const DefaultModal: React.FC<React.PropsWithChildren<TDefaultModalProps>> = ({ children, onClose, ...props }) => {
  const handleOnClose: TDefaultModalProps["onClose"] = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }

    onClose?.(event, reason);
  };

  return (
    <Modal
      onClose={handleOnClose}
      {...props}
    >
      {children}
    </Modal>
  );
};

export default DefaultModal;
